import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {fromJS} from 'immutable';
import {Router} from 'react-router';
import {push, replace} from 'react-router-redux';
import {connect} from 'react-redux';
import {StyleRoot} from 'radium';
import loadjs from 'loadjs';
import {createSelector} from 'reselect';

import * as styles from '../styles';
import Topbar from '../topbar/Topbar.js';
import StickyDrawerMenu from './StickyDrawerMenu.js';
import ContentManager from '../content-manager/content_manager';
import LoginDialog from './login_dialog';
import RegistrationDialog from './registration_dialog.js';
import WelcomeDialog from './WelcomeDialog.jsx';
import {setItems as setMenuItems} from '../menu/actions';
import {close, open} from '../dialog/actions';
import {fetchUser, request, setComponentInitialState, setApplication, setDefaultApplication,
    enterAdminPage, enterNormalPage, MODE_CONCENTRATE, PAGE_ADMIN, PAGE_NORMAL} from './actions';
import { allComponents, rawRoutes, tomMainMenu, updateRoutes } from './PagesAndMenus';


class Dialogs extends React.Component {
    static contextTypes = {
        store: PropTypes.object,
    }


    componentDidMount() {
        this.handleModals.bind(this)({});
    }


    componentDidUpdate(prevProps) {
        this.handleModals.bind(this)(prevProps);
    }


    handleModals(props) {
        const previousLocation = props.location;
        const currentLocation = this.props.location;
        const previousDialog = previousLocation
            ? (
                previousLocation.hash.dialog ||
                previousLocation.query.dialog
            )
            : undefined;
        const currentDialog = (
            currentLocation.hash.dialog ||
            currentLocation.query.dialog
        );

        _.forEach(['login', 'registration', 'welcome'], dialogId => {
            if (
                props.dialogs &&
                this.props.dialogs.getIn([dialogId, 'isOpen']) !== props.dialogs.getIn([dialogId, 'isOpen']) &&
                props.dialogs.getIn([dialogId, 'isOpen']) &&
                currentDialog === dialogId
            ) {
                this.context.store.dispatch(push({
                    ...currentLocation,
                    query: {...currentLocation.query, dialog: undefined},
                }));
            }
        });

        if (previousDialog !== currentDialog) {
            if (previousDialog)
                this.context.store.dispatch(close(this.props.dialogs.getIn([previousDialog, 'elementId'])));
            if (currentDialog)
                this.context.store.dispatch(open(this.props.dialogs.getIn([currentDialog, 'elementId'])));
        }
    }


    render() {
        return <span>
            <LoginDialog
                {...this.props.dialogs.get('login').toJS()}
                loginError={this.props.loginError}
            />
            <RegistrationDialog {...this.props.dialogs.get('registration').toJS()} extra={this.props.dialogs.get('extra')}/>
            <WelcomeDialog {...this.props.dialogs.get('welcome').toJS()} user={this.props.user}/>
            {this.props.children}
        </span>;
    }
}


const topbarSelector = createSelector(
    [
        state => state.get('topbar'),
        state => state.getIn(['application', 'unreadMessages']),
        state => state.getIn(['application', 'components', 'cart', 'cart', 'main', 'items']),
        state => state.getIn(['application', 'user', 'pending_orders']),
        state => state.getIn(['application', 'application']),
        state => state.getIn(['routing', 'locationBeforeTransitions', 'pathname']),
    ],
    (topbarState, unreadMessages, shoppingItems, pendingOrders, application) => ({
        ...topbarState.toJS(),
        unreadMessages,
        shoppingItems,
        pendingOrders,
        application,
    }),
);
const stickyDrawerSelector = createSelector(
    [state => state.get('drawer')],
    drawerState => drawerState.toJS(),
);
let ConnectedTopbar = connect(
    state => topbarSelector(state),
    undefined,
    undefined,
    {pure: false},
)(Topbar);
let ConnectedStickyDrawerMenu = connect(
    state => stickyDrawerSelector(state),
)(StickyDrawerMenu);



const connectedContentManager = connect((state, ownProps) => ({
    ...state.get('content').toJS(),
    uri: '/' + ownProps.params.splat,
}))(ContentManager);

export const components = {};
_.forEach(
    allComponents,
    (module, name) => {
        const component = props => <ErrorBoundary>
            <module.component {...props}/>
        </ErrorBoundary>;
        components[name] = {
            ...module,
            // required: true,
            component,
        };
    },
);


class ErrorBoundary extends React.PureComponent {
    state = {errorCatched: false}

    componentDidCatch(error, info) {
        this.setState({errorCatched: true});
        console.log(error, info);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.children.type !== this.props.children.type) {
            this.setState({errorCatched: false});
        }
    }

    render() {
        if (this.state.errorCatched)
            return '';
        return this.props.children;
    }
}

class Application_ extends React.PureComponent {
    static childContextTypes = {
        user: PropTypes.shape({
            longname: PropTypes.string,
            shortname: PropTypes.string,
            id: PropTypes.number,//.isRequired,
            profilePicture: PropTypes.string,
        }),
        application: PropTypes.string,
        pending: PropTypes.number,
    }

    static contextTypes = {
        store: PropTypes.object,
    }

    state = {
        eNamad: true,
    }

    userRoutes = [];

    constructor(props, context) {
        super(props, context);
        this.userRoutes = [];
        this.instances = {};
        const dialogsSelector = createSelector(
            [
                state => state.get('dialogs'),
                state => state.getIn(['application', 'loginError']),
                () => this.props.user,
            ],
            (dialogs, loginError, user) => ({dialogs, loginError, user}),
        );
        this.routes = {
            childRoutes: [{
                component: connect(state => dialogsSelector(state))(Dialogs),
                getChildRoutes: (partialNextState, callback) => {
                    callback(null, [
                        ...this.userRoutes,
                        {
                            path: '/**',
                            getComponent: (partialNextState, callback) => {
                                const expectedApplication = (
                                    this.context.store.getState().getIn(['content', 'content', 'application', 'name']) ||
                                    this.context.store.getState().getIn(['application', 'defaultApplication'])
                                );

                                if (this.context.store.getState().getIn(['application', 'pageType']) !== PAGE_NORMAL)
                                    this.props.dispatch(enterNormalPage());
                                if (this.context.store.getState().getIn(['application', 'application']) !== expectedApplication)
                                    this.props.dispatch(setApplication(expectedApplication));
                                if (this.state.application)
                                    this.setState({application: false});
                                this.setState({eNamad: partialNextState.location.pathname === '/'});
                                callback(null, connectedContentManager);
                            },
                        },
                    ]);
                },
            }],
        };
    }

    getChildContext() {
        return {
            user: this.props.user,
            application: this.props.application,
            pending: this.props.pending,
        };
    }

    async instantiate(component, file, instanceId, props) {
        const instantiate = async () => {
                        const module = typeof(component)==='object'?component:components[component];
            this.instances[instanceId] = {props};
            if(module.reducer !== undefined) {
                if ( !module || !module[instanceId] ) {
                    let state = fromJS(module.initialState);
                    state = module.reducer(state, {type: '__JUST_INITIALIZE'});
                    await this.props.dispatch(setComponentInitialState(component, instanceId, state));
                }
                const getInstanceProps = createSelector(
                    [state => state.get('application').get('components').get(component).get(instanceId)],
                    state => ({store: state, ...props}),
                );
                
                this.instances[instanceId].instance = connect(
                    state => getInstanceProps(state),
                )(module.component);
            } else {
                this.instances[instanceId].instance = connect(
                    state => (state),
                )(module.component);
            }
            this.instances[instanceId].component = component;
            this.instances[instanceId].initialized = true;
        };
        if (this.instances[instanceId] && !_.isEqual(this.instances[instanceId].props, props)) {
            delete this.instances[instanceId];
        }
                if (this.instances[instanceId]) {
            if (this.instances[instanceId].initialized)
                return this.instances[instanceId];
        }
        else if (typeof(component) === 'object' || components[component]) {
            // if (components[component].required) {
                        await instantiate();
            return this.instances[instanceId];
            // }
        }
        // else {
        //     components[component] = {};
        //     await new Promise(resolve => {
        //         loadjs([file], {
        //             success: async () => {
        //                 components[component] = require('../components/' + component);
        //                 components[component].required = true;
        //                 const Component = components[component].component;
        //                 components[component].component = props => <ErrorBoundary>
        //                     <Component {...props}/>
        //                 </ErrorBoundary>;
        //                 await instantiate();
        //                 resolve();
        //             },
        //         });
        //     });
        //     return this.instances[instanceId];
        // }
        return null;
    }

    convertRoutes(routes, parentPath = '', application = this.props.user ? this.props.user.default_application : 'main') {
        return _.map(
            routes,
            route => ({
                path: route.path,
                getComponent: async () => {
                    const _application = route.application || application || this.context.store.getState().getIn(['application', 'defaultApplication']);
                    if (this.context.store.getState().getIn(['application', 'application']) !== _application)
                        this.props.dispatch(setApplication(_application));
                    if (this.context.store.getState().getIn(['application', 'pageType']) !== PAGE_ADMIN)
                        this.props.dispatch(enterAdminPage());
                    const instanceId = parentPath + route.path;
                    route.props = route.props || {};
                    const instance = await this.instantiate.bind(this)(
                        route.component,
                        route.file,
                        instanceId,
                        {...route.props, urls: route.props.urls || {}},
                    );
                    if (!this.state.application)
                        this.setState({application: true});
                    let comp = typeof(route.component)==='object'?route.component:components[route.component];
                    this.setState({eNamad: comp.eNamad === true});
                    if (instance)
                        return instance.instance;
                    return null;
                },
                getChildRoutes: (__, callback) => callback(null, this.convertRoutes.bind(this)(route.childRoutes, route.path, route.application || application)),
            }),
        );
    }

    async convertMenu(items) {
        const result = [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            result.push({
                ...item,
                text: item.text ? item.text.persian() : item.text,
                items: item.items ? (await this.convertMenu.bind(this)(item.items)) : undefined, 
                component: item.component
                    ? (await this.instantiate.bind(this)( 
                        item.component,
                        item.file,
                        item.component,
                        item.props,
                    )).instance
                    : undefined,
            });
        }
        return result;
    }

    fetchData() {
        if (this.props.token && this.props.token.accessToken) {
            (async () => {
                await this.props.dispatch(fetchUser());
                this.fetchRoutes();
                this.fetchMenus();
            })();
        }
        else {
            this.fetchRoutes();
            this.fetchMenus();
        }
    }

    async fetchRoutes() {
        this.rawRoutes = await this.props.dispatch(request('/user/routes/'));
        this.rawRoutes = updateRoutes(this.rawRoutes);
        this.userRoutes = this.convertRoutes.bind(this)(this.rawRoutes);
    }

    async fetchDrawerMenu() {
        const drawerMenu = await this.convertMenu.bind(this)(await this.props.dispatch(request('/user/menu/')));
        this.props.dispatch(setMenuItems(drawerMenu, this.context.store.getState().getIn(['drawer', 'elementId'])));
    }

    async fetchTopbarMenu() {
        const application = this.props.application;
        (async () => {
            const topbarMenu = await this.convertMenu.bind(this)(
                await this.props.dispatch(request(`/user/menu/${application}/`)),
            );
            if (application === this.props.application)
                this.props.dispatch(setMenuItems(topbarMenu, this.context.store.getState().getIn(['topbar', 'menu', 'elementId'])));
        })();
        (async () => {
            const applicationsMenu = tomMainMenu;//await this.props.dispatch(request('/content/?application=True&minimal&o=order'));
            if (application === this.props.application)
                this.props.dispatch(setMenuItems(
                    applicationsMenu.results,
                    this.context.store.getState().getIn(['topbar', 'applicationsMenu', 'elementId']),
                ));
        })();
    }

    async fetchMenus() {
        this.fetchDrawerMenu.bind(this)();
        this.fetchTopbarMenu.bind(this)();
    }

    componentDidMount() {
        this.fetchData.bind(this)();
    }

    async componentDidUpdate(prevProps) {
        if (
            (prevProps.token && prevProps.token.accessToken) !== (this.props.token && this.props.token.accessToken) &&
            this.props.token && this.props.token.accessToken
        ) {
            this.fetchData.bind(this)();
            const location = this.context.store.getState().get('routing').get('locationBeforeTransitions').toJS();
            const nextPage = (
                location.hash.next ||
                location.query.next
            );
            if (nextPage !== undefined) {
                this.props.dispatch(push({
                    ...location,
                    pathname: nextPage === '-' ? location.path : nextPage,
                    query: {...location.query, next: undefined},
                }));
            }
            else {
                this.setState({newLogin: true});
            }
        }

        if ((prevProps.user ? prevProps.user.id : null) !==
            (this.props.user ? this.props.user.id : null) && this.props.user && this.props.user.home_page && this.state.newLogin) {
            this.props.dispatch(push({
                ...window.location,
                pathname: this.props.user.home_page,
                query: {...window.location.query, dialog: 'welcome'},
            }));
            this.setState({newLogin: false});
        }
        if (prevProps.application !== this.props.application) {
            await this.fetchTopbarMenu.bind(this)();
        }

        if ((prevProps.user ? prevProps.user.default_application : null) !==
            (this.props.user ? this.props.user.default_application : null)) {
            this.props.dispatch(setDefaultApplication(this.props.user.default_application || 'main'));
        }

        if (prevProps.defaultApplication !== this.props.defaultApplication) {
            this.userRoutes = this.convertRoutes.bind(this)(this.rawRoutes);
        }

        if (prevProps.fetchInformationCounter !== this.props.fetchInformationCounter) {
            this.fetchDrawerMenu.bind(this)();
            this.props.dispatch(fetchUser());
        }
    }

    render() {
        return <StyleRoot style={{height: '100%'}}>
            <div
                style={{
                    ...styles.overlay,
                    pointerEvents: this.props.pending ? undefined : 'none',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    opacity: this.props.pending ? '1' : '0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    transition: 'opacity 200ms',
                    color: styles.thirdColor,
                    zIndex: 10000,
                }}>
                <i className='fa-spin fa-spinner fa-4x'></i>
            </div>
            {this.state.eNamad && window.location.host.indexOf('localhost')==-1
                ? <div style={{position: 'fixed', bottom: '1em', left: '1em', zIndex: '100'}}>
                    {/* <img
                        id='hwlahwlawmcsnbpe'
                        style={{cursor: 'pointer'}}
                        onClick={() => window.open(
                            'https://trustseal.enamad.ir/Verify.aspx?id=4482&p=odshodshaqgwwkyn',
                            'Popup',
                            'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30',
                        )}
                        onMouseDown={event => {
                            if (!event.altKey || !event.ctrlKey || event.button !== 2)
                                return;
                            event.preventDefault();
                            event.stopPropagation();
                            this.setState({eNamad: true});
                        }}
                        onContextMenu={event => event.preventDefault()}
                        alt=''
                        src='https://trustseal.enamad.ir/logo.aspx?id=4482&p=aodsaodsukaqqesg'
                    /> */}
                </div>
                : null
            }
            <div style={{float: 'left', width: '100%'}}>
                <ConnectedTopbar
                    topRowHeight={60}
                    topRowMinimumHeight={60}
                    topRowBarHeight={60}
                    bottomRowHeight={26}
                />
            </div>
            <div style={{clear: 'both'}}/>
            {this.props.mode === MODE_CONCENTRATE
                ? null
                : <ConnectedStickyDrawerMenu/>
            }
            <div style={{...styles.row, ...styles.page, backgroundColor: this.state.application ? 'white' : undefined}} id='page'>
                <Router history={this.props.history} routes={this.routes}/>
            </div>
        </StyleRoot>;
    }
};
export const Application = connect(
    state => (state.get('application').toJS()),
)(Application_);
